import moment from 'moment';
// Date Filter
export default function DateFilter($ngRedux, TimezoneService) {
  'ngInject';
  //pass formatOnly as format to just format date with no conversion
  return function(input, formatOnly) {
    if (!input) return;
    let dateFormat = '';
    if ($ngRedux !== undefined) {
      const store = $ngRedux.getState();
      dateFormat = store.user.dateFormat;
    }

    if (formatOnly === 'format-only') {
      return moment(input).format(dateFormat);
    }
    return TimezoneService.convertToUserTimezone(input, dateFormat);
  };
}
